export default "__VITE_PUBLIC_ASSET__2c46771f__"